import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { useGetAddressType } from "@common/hook/useGetAddressType";
import { EADDRESS_TYPES } from "@constants";
import { BillingAddressForm } from "./BillingAddressForm";

export const MyBillingAddress = () => {
    const { addressField, getUserAddress, getUserAddressState } = useGetAddressType(EADDRESS_TYPES.BILLING);

    return (
        <HandleErrorAndLoading
            error={getUserAddressState.error}
            isLoading={getUserAddressState.isLoading}
            retryFetch={getUserAddress}
        >
            {addressField && <BillingAddressForm userAddress={addressField} getUserAddress={getUserAddress} />}
        </HandleErrorAndLoading>
    );
};
